import { getDefaultStore } from "jotai";

export const store = getDefaultStore();
